export interface IAccountsList {
  accountId: string;
  deleted?: boolean;
  businessName: string;
  webName: string;
  dateCreated: string;
  pciDss: boolean;
  creator: string;
  notes: string;
  bucketId: string;
  influxDB: IInfluxDB;
  grafana: IGrafana;
  termsAcceptedBy: string;
  accountType: AccountType;
  billingStyle: BillingStyle;
  billingAccountId: number;
  paymentMethodCreated: boolean;
  lastRefill: ILastRefill;
  creatorEmail: string;
  lastLoginDate: string;
  currentBalance: number;
  numberCloudContexts: number;
  lastUsedEpoch: number;
  numberEdgeDeployments: number;
  numberWebsockets: number;
  numberUsers: number;
  referrer: string;
  referrals: { [key: string]: string };
  premiumFeatures: string[];
  availableFeatureDetails: availableFeatureDetails;
  mainMode: string;
  phoneNumbers: IPhoneNumbers[];
  status: AccountStatus;
  color: string;
  timeZone: string;
  weekStartsOn: WeekStartsOn;
  timeFormat: TimeFormat;
  dateFormat: "mm/dd/yyyy" | "dd/mm/yyyy" | "yyy/mm/dd";
  saDemoContext: string;
  numberEmployees: string;
  postalAddress: string;
  limits: ILimits;
  saAppHiddenFeatures: string[];
}
export enum BillingStyle {
  ManualRefill = "MANUAL-REFILL",
  AutoRefill = "AUTO-REFILL",
  Invoice = "INVOICE",
}
export enum availableFeatureDetails {
  Greg = "GREG",
  SpeechAnalytics = "SpeechAnalytics",
}
export enum AccountType {
  Acp = "ACP",
  SpeechWorks = "SPEECH-WORKS",
  SpeechAnalytics = "SPEECH-ANALYTICS",
}
export enum TimeFormat {
  TwelveHour = "12Hour",
  TwentyFourHour = "24Hour",
}
export enum WeekStartsOn {
  Sunday = "Sunday",
  Monday = "Monday",
}
export enum AccountStatus {
  Active = "active",
  Pending = "pending",
  Suspended = "suspended",
}
export interface IPhoneNumbers {
  e164Number: string;
  isTollFree: boolean;
  state: string;
  city: string;
  setupCost: number;
  mrc: number;
  purchaseDate: string;
  lastBilledDate: string;
  provisioningStatus: ProvisioningStatus;
  lastMRCDate: string;
}
interface ILimits {
  apiRequestLimitPerMinute: number;
  apiRequestLimitPerHour: number;
  asrConcurrencyLimit: number;
  offlineQueueSizeLimit: number;
  offlineThroughputLimitPerHour: number;
  offlineWorkerLimit: number;
}
interface IInfluxDB {
  host: string;
  port: number;
  username: string;
  password: string;
  database: string;
  ssl: boolean;
}
interface IGrafana {
  orgName: string;
  orgId: string;
}
interface ILastRefill {
  requestingUser: string;
  amount: number;
  balanceAfter: number;
}

export enum ProvisioningStatus {
  Provisioning = "provisioning",
  Completed = "completed",
  Error = "error",
  Deleted = "deleted",
  Assigned = "assigned",
}

export interface IAccountPhoneNumbers {
  accountId: string;
  webName: string;
  phoneNumber: IPhoneNumbers;
}
